var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQrVcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 3.5,
    width: 19,
    height: 24,
    rx: 1.5,
    fill: "#F2F2F2",
    stroke: "#595959"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5.5,
    width: 19,
    height: 24,
    rx: 1.5,
    fill: "white",
    stroke: "#595959"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 24,
    width: 10,
    height: 1,
    rx: 0.5,
    fill: "#595959"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 26,
    width: 6,
    height: 1,
    rx: 0.5,
    fill: "#595959"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 20,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#595959"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 20,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#595959"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 20,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#595959"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7017 15.2636C11.9884 14.3123 13.9697 13.8333 15.0001 13.8333C16.0304 13.8333 18.0115 14.3123 18.2984 15.2635C18.741 14.6198 19 13.8402 19 13C19 10.7909 17.2091 9 15 9C12.7909 9 11 10.7909 11 13C11 13.8402 11.2591 14.62 11.7017 15.2636ZM20 13C20 15.7614 17.7614 18 15 18C12.2386 18 10 15.7614 10 13C10 10.2386 12.2386 8 15 8C17.7614 8 20 10.2386 20 13ZM16.6667 11.3333C16.6667 12.2542 15.9209 13 15.0001 13C14.0792 13 13.3334 12.2542 13.3334 11.3333C13.3334 10.4125 14.0792 9.66667 15.0001 9.66667C15.9209 9.66667 16.6667 10.4125 16.6667 11.3333Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQrVcard);
export default __webpack_public_path__ + "static/media/icon-qr-vcard.c09b5a7cc449e02ca312e0592bc7c2e3.svg";
export { ForwardRef as ReactComponent };